import { SettingsParser } from "./settings-parser";
import { ChannelCommonSettings } from "../settings/channel-common-settings";
import { getItemByField } from "../../../../../web-graphics";

export class CommonChannelParser extends SettingsParser {
  constructor(configurationParser) {
    super();
    this.parsedFieldNames = [
      "id",
      "name",
      "original",
      "hasVariableIsoline",
      "hasNullableData",
      "unit",
      "defaultConfiguration",
      "currConfiguration",
      "defaultFreq",
      "configurations",
      "signals" // default configuration field
    ];
    this.configurationParser = configurationParser;
  }

  static createSettings(settings, defaultSettings, configurationParser) {
    if (settings === undefined) {
      return undefined;
    }
    let parsedSettings = {
      id: settings.id, // type: int
      name: settings.name, // type: string
      original: settings.original ?? defaultSettings?.original ?? true, // type: bool
      maxSignalCount: settings.maxSignalCount, // type: int
      hasVariableIsoline: settings.hasVariableIsoline ?? defaultSettings?.hasVariableIsoline ?? true, // type: bool
      hasNullableData: settings.hasNullableData ?? defaultSettings?.hasNullableData ?? true,
      unit: settings.unit ?? defaultSettings?.unit, // type: string
      defaultConfiguration: settings.defaultConfiguration,
      currConfiguration: settings.currConfiguration, // type: string
      defaultFreq: settings.defaultFreq ?? defaultSettings?.defaultFreq // type: int
    };
    if (parsedSettings.defaultConfiguration === undefined) {
      parsedSettings.defaultConfiguration = parsedSettings.currConfiguration;
    } else if (parsedSettings.currConfiguration === undefined) {
      parsedSettings.currConfiguration = parsedSettings.defaultConfiguration;
    }
    let configurations = [];
    if (parsedSettings.defaultConfiguration === undefined && settings.configurations === undefined && settings.signals !== undefined) {
      parsedSettings.defaultConfiguration = "default";
      parsedSettings.currConfiguration = parsedSettings.defaultConfiguration;
      configurations.push({
        name: "default",
        signals: settings.signals
      });
    } else {
      configurations = settings.configurations;
    }
    if (configurations !== undefined && configurationParser !== undefined) {
      parsedSettings.configurations = [];
      for (let configIndex = 0; configIndex < configurations.length; configIndex++) {
        let configurationSettings = configurationParser.parse(configurations[configIndex], defaultSettings?.configuration);
        if (configurationSettings !== undefined) {
          parsedSettings.configurations.push(configurationSettings);
        }
      }
    }
    if (parsedSettings.maxSignalCount === undefined) {
      if (configurations.length == 0) {
        parsedSettings.maxSignalCount = 0;
      } else {
        const currConfiguration = getItemByField("name", parsedSettings.defaultConfiguration, configurations);
        if (currConfiguration === undefined) {
          parsedSettings.maxSignalCount = 0;
        } else {
          parsedSettings.maxSignalCount = currConfiguration.signals.length;
        }
      }
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = CommonChannelParser.createSettings(settings, defaultSettings, this.configurationParser);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new ChannelCommonSettings(parsedSettings);
  }
}
